export interface RRIPagination {
  currentPage: number;
  pageCount: number;
  pageSize: number;
  recordCount: number;
  recordCountHidden?: number;
}
